import { usePiegeFocus } from './usePiegeFocus.js';
import { IconButton } from '@artosera/ui';
import type { Sujet } from '@artosera/shared';
import { X } from 'lucide-react';
import type { JSX } from 'react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { GalerieSession } from '../../api/types.js';
import { Sidebar } from './Sidebar.js';
import styles from './MobileNav.module.css';

export interface MobileNavProps {
  open: boolean;
  onClose: () => void;
  galerie: GalerieSession;
  galerieSlug: string;
  sujetGroupe: Sujet | null;
  modulesAVenir?: number;
  nonLues?: number;
}

/** Menu mobile et scrim sous 850 px (3.2, mission S3-i point 2). */
export function MobileNav({
  open,
  onClose,
  galerie,
  galerieSlug,
  sujetGroupe,
  modulesAVenir = 0,
  nonLues = 0,
}: MobileNavProps): JSX.Element | null {
  const { t } = useTranslation('regie');
  const tiroir = useRef<HTMLDivElement>(null);
  usePiegeFocus(tiroir, open);

  useEffect(() => {
    if (!open) return;
    const surEchap = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', surEchap);
    return () => document.removeEventListener('keydown', surEchap);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={styles.enveloppe}>
      <button
        type="button"
        className={styles.scrim}
        tabIndex={-1}
        aria-label={t('coquille.menuMobileFermer')}
        onClick={onClose}
      />
      <div
        className={styles.tiroir}
        ref={tiroir}
        role="dialog"
        aria-modal="true"
        aria-label={t('coquille.menuMobileTitre')}
      >
        <IconButton
          className={styles.fermer}
          icon={<X aria-hidden />}
          aria-label={t('coquille.menuMobileFermer')}
          onClick={onClose}
        />
        <Sidebar
          dansMenuMobile
          galerie={galerie}
          galerieSlug={galerieSlug}
          sujetGroupe={sujetGroupe}
          modulesAVenir={modulesAVenir}
          nonLues={nonLues}
          reduite={false}
          onReduireChange={() => {}}
        />
      </div>
    </div>
  );
}
